'use client';
var classes = {"root":"m_48204f9b","marks":"m_bb9cdbad","mark":"m_481dd586","thumb":"m_bc02ba3d","label":"m_bb8e875b"};

export { classes as default };
//# sourceMappingURL=AngleSlider.module.css.mjs.map
